import type { JSX } from 'react';
import { classes } from '../../../utils/classes';
import { type CmsData, ComponentTypes } from '../../../../interfaces';
import { Html } from '../../Html/Html';
import { ModalByTextlink } from '../../ModalByTextlink/ModalByTextlink';
import type { FooterBlockType } from '../types';

type SocketProps = {
  data: CmsData;
};

export const AreaSocket = ({ data }: SocketProps): JSX.Element => {
  const comp = (data.paragraph as FooterBlockType[])
    ?.filter((item) => item.parent_field_name === 'field_socket')
    ?.map((item, index) => {
      const keyModalByTextlink = `socket-${ComponentTypes.TextlinkModal}-${index}`;
      const keyHtml = `socket-${ComponentTypes.Html}-${index}`;
      if (item.type === ComponentTypes.TextlinkModal) {
        return <ModalByTextlink key={keyModalByTextlink} data={item} />;
      }

      if (item.type === ComponentTypes.Html) {
        return <Html key={keyHtml} data={item} />;
      }

      // eslint-disable-next-line react/no-array-index-key
      return <div key={`socket-${index}`} />;
    });

  if (data && comp.length > 0) {
    return (
      <div
        className={classes(
          'text-color-footer-contrasttext text-size-body2 mx-auto max-w-screen-xl px-2! pt-3 pb-[4.5rem]',
          'md:text-size-body3 md:px-0!',
          '[&_a]:text-color-footer-contrasttext! [&_a]:decoration-color-text [&_a]:no-underline',
          '[&_p]:m-0 [&_p]:p-0 [&_p_+_p]:pt-1.5! md:[&_p_+_p]:pt-1!',
        )}
      >
        {comp}
      </div>
    );
  }

  return <div />;
};
